import { render, staticRenderFns } from "./UpcomingContent.vue?vue&type=template&id=54cbda8e"
import script from "./UpcomingContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpcomingContent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UpcomingContent.vue?vue&type=style&index=0&id=54cbda8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports